/**
 * Верхняя граница размера видеофайла для загрузки: предел Cloudflare Stream
 * для tus-загрузки (30 ГБ). `fileSize` в `requestVideoUpload` и
 * `requestTusVideoUpload` объявлен как `Float`, поэтому 32-битного предела
 * GraphQL `Int` здесь нет. Проверяем размер на клиенте до запроса загрузки,
 * чтобы не гнать гигабайты ради отказа провайдера посреди закачки.
 */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 30_000_000_000;

export const isFileTooLargeForUpload = (file: File): boolean =>
  file.size > MAX_UPLOAD_FILE_SIZE_BYTES;
